import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { MapPin, Clock, Globe, MessageCircle } from 'lucide-react';
export function Contact() {
  const handleBooking = (e: React.FormEvent) => {
    e.preventDefault();
    window.open('https://studiomery.koob.uy', '_blank', 'noopener,noreferrer');
  };
  return <section id="contacto" className="py-24 bg-white" data-id="element-22">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-23">
        <div className="text-center mb-16" data-id="element-24">
          <h2 className="text-sm font-medium text-rosegold tracking-widest uppercase mb-3" data-id="element-25">
            Contacto
          </h2>
          <h3 className="text-4xl md:text-5xl font-serif text-charcoal" data-id="element-26">
            Reservá tu turno
          </h3>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-27">
          {/* Left Side: Info */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-28">
            <h4 className="text-2xl font-serif text-charcoal mb-8" data-id="element-29">
              Te esperamos
            </h4>

            <div className="space-y-6 mb-10" data-id="element-30">
              <div className="flex items-start gap-4" data-id="element-31">
                <div className="w-10 h-10 rounded-full bg-cream flex items-center justify-center flex-shrink-0 text-rosegold" data-id="element-32">
                  <MapPin size={20} data-id="element-33" />
                </div>
                <div data-id="element-34">
                  <p className="font-medium text-charcoal mb-1" data-id="element-35">Ubicación</p>
                  <p className="text-charcoal-light font-light" data-id="element-36">
                    Francisco Ros 2779
                    <br data-id="element-37" />
                    Punta Carretas, Montevideo
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-38">
                <div className="w-10 h-10 rounded-full bg-cream flex items-center justify-center flex-shrink-0 text-rosegold" data-id="element-39">
                  <Clock size={20} data-id="element-40" />
                </div>
                <div data-id="element-41">
                  <p className="font-medium text-charcoal mb-1" data-id="element-42">
                    Horarios de atención
                  </p>
                  <p className="text-charcoal-light font-light" data-id="element-43">
                    Lunes a Viernes: 10:00 - 20:00
                    <br data-id="element-44" />
                    Sábados: 10:00 - 15:00
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-45">
                <div className="w-10 h-10 rounded-full bg-cream flex items-center justify-center flex-shrink-0 text-rosegold" data-id="element-46">
                  <Globe size={20} data-id="element-47" />
                </div>
                <div data-id="element-48">
                  <p className="font-medium text-charcoal mb-1" data-id="element-49">
                    Agenda Online
                  </p>
                  <a href="https://studiomery.koob.uy" target="_blank" rel="noopener noreferrer" className="text-rosegold hover:underline font-light" data-id="element-50">
                    studiomery.koob.uy
                  </a>
                </div>
              </div>
            </div>

            {/* Interactive Google Map */}
            <div className="mt-10 w-full h-64 bg-cream-dark rounded-2xl overflow-hidden relative border border-cream shadow-sm" data-id="element-51">
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3271.393433722956!2d-56.1592652!3d-34.9216776!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x959f818b26e2a225%3A0x15f1c951152a2656!2sFrancisco%20Ros%202779%2C%2011300%20Montevideo%2C%20Departamento%20de%20Montevideo%2C%20Uruguay!5e0!3m2!1sen!2sus!4v1700000000000!5m2!1sen!2sus" width="100%" height="100%" style={{
              border: 0
            }} allowFullScreen={false} loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Ubicación de Studio by Mery" className="absolute inset-0" data-id="element-52"></iframe>
            </div>
          </motion.div>

          {/* Right Side: Form */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-cream p-8 md:p-10 rounded-3xl" data-id="element-53">
            <h4 className="text-2xl font-serif text-charcoal mb-2" data-id="element-54">
              Solicitar reserva
            </h4>
            <p className="text-charcoal-light font-light mb-8" data-id="element-55">
              Completá tus datos y te redirigiremos a nuestra agenda online para
              confirmar tu turno.
            </p>

            <form onSubmit={handleBooking} className="space-y-6" data-id="element-56">
              <div data-id="element-57">
                <label htmlFor="name" className="block text-sm font-medium text-charcoal mb-2" data-id="element-58">
                  Nombre completo
                </label>
                <input type="text" id="name" required className="w-full px-4 py-3 rounded-xl border border-cream-dark bg-white focus:outline-none focus:ring-2 focus:ring-rosegold/50 focus:border-rosegold transition-colors" placeholder="Tu nombre" data-id="element-59" />
              </div>

              <div data-id="element-60">
                <label htmlFor="service" className="block text-sm font-medium text-charcoal mb-2" data-id="element-61">
                  Servicio de interés
                </label>
                <select id="service" required className="w-full px-4 py-3 rounded-xl border border-cream-dark bg-white focus:outline-none focus:ring-2 focus:ring-rosegold/50 focus:border-rosegold transition-colors appearance-none" data-id="element-62">
                  <option value="" disabled selected data-id="element-63">
                    Seleccioná un servicio
                  </option>
                  <optgroup label="Belleza" data-id="element-64">
                    <option value="nails" data-id="element-65">Nails (Esculpidas, Gel, etc.)</option>
                    <option value="lashes" data-id="element-66">
                      Lashes (Extensiones, Lifting)
                    </option>
                    <option value="brows" data-id="element-67">Brows (Diseño, Laminado)</option>
                    <option value="faciales" data-id="element-68">Faciales Premium</option>
                  </optgroup>
                  <optgroup label="Bienestar" data-id="element-69">
                    <option value="masaje-terapeutico" data-id="element-70">
                      Masaje Terapéutico
                    </option>
                    <option value="masaje-relajante" data-id="element-71">Masaje Relajante</option>
                    <option value="masaje-deportivo" data-id="element-72">Masaje Deportivo</option>
                    <option value="masaje-piedras" data-id="element-73">Masaje con Piedras</option>
                  </optgroup>
                </select>
              </div>

              <div data-id="element-74">
                <label htmlFor="message" className="block text-sm font-medium text-charcoal mb-2" data-id="element-75">
                  Mensaje (Opcional)
                </label>
                <textarea id="message" rows={4} className="w-full px-4 py-3 rounded-xl border border-cream-dark bg-white focus:outline-none focus:ring-2 focus:ring-rosegold/50 focus:border-rosegold transition-colors resize-none" placeholder="¿Alguna consulta adicional?" data-id="element-76"></textarea>
              </div>

              <button type="submit" className="w-full bg-charcoal text-white px-6 py-4 rounded-xl font-medium hover:bg-charcoal-light transition-colors shadow-md flex items-center justify-center gap-2" data-id="element-77">
                Continuar a la agenda online
                <Globe size={18} data-id="element-78" />
              </button>
            </form>
          </motion.div>
        </div>
      </div>
    </section>;
}